const decodeHandlebarsAttribute = (value: string): string =>
  value
    .replace(/&quot;/g, '"')
    .replace(/&apos;|&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&lbrace;/g, '{')
    .replace(/&rbrace;/g, '}')
    .replace(/&#123;/g, '{')
    .replace(/&#125;/g, '}')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>');

const replacePlaceholderRows = (
  html: string,
  attribute: 'data-hbs-open' | 'data-hbs-close'
): string => {
  const regex = new RegExp(
    `(\\s*)<tr[^>]*?${attribute}\\s*=\\s*["']([^"']+?)["'][^>]*?>[\\s\\S]*?<\\/tr>`,
    'g'
  );

  return html.replace(regex, (match, leadingWhitespace, expression) => {
    const decoded = decodeHandlebarsAttribute(expression);
    return `${leadingWhitespace}${decoded}`;
  });
};

export const restoreHandlebarsBlockPlaceholders = (html: string): string => {
  const afterOpen = replacePlaceholderRows(html, 'data-hbs-open');
  const afterClose = replacePlaceholderRows(afterOpen, 'data-hbs-close');
  return afterClose;
};
